/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { CardsSimpleComponentEditor } from "cms/components/components/cards-simple/edit";
import { CardsSimpleComponentDisplay } from "cms/components/components/cards-simple/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const CardsSimpleComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <CardsSimpleComponentDisplay />,
        editComponent: <CardsSimpleComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

CardsSimpleComponent.displayName = "CardsSimpleComponent";
export { CardsSimpleComponent };
